import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  useTheme,
  Dialog,
  DialogTitle,
  Button,
  DialogContentText,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useEffect,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";
import { useTranslation } from "react-i18next";
import axios, { AxiosResponse } from "axios";
import dayjs from "dayjs";
//src
import Check from "../../../../images/icons/white_edit/Check_white.svg";
import MOCK_IMAGE from "../../../../images/mock_images/pointcloud_img2.png";
import AR_IMAGE from "../../../../images/mock_images/ar_img.png";
import { config } from "../../../config/config";
import { deleteContext } from "../../../pages/Home";
import { useInView } from "react-intersection-observer";
import { MoreVert } from "@mui/icons-material";
import RenameProjectDialog from "../../RenameProjectDialog";
import DeleteProjectDialog from "../../DeleteProjectDialog";
import { Common } from "../../../../common/src";
import DownloadingIcon from "@mui/icons-material/Downloading";
import { t } from "i18next";
import POINT_REMOVE_WHITE_IMG from "../../../../images/icons/white_edit/point_remove.svg";
import POINT_REMOVE_IMG from "../../../../images/icons/point_remove.svg";
import ChevronRight from "../../../../images/icons/neutral_edit/Chevron Right.svg";
import Icon from "../../Icon";
import ARListDialog from "../../ARListDialog";
import UploadBaseDialog from "../../UploadBaseDialog";
import { UserSiteContext } from "../../../..";
import { projectDetailAPIs } from "../../../api/project";

type StatusIconProps = {
  status: 0 | 1 | 2; // 0:default/1:success/2:error
  number: number;
};

//new status text
const StatusIcon = (props: StatusIconProps) => {
  return (
    <Box component={"div"} sx={{ display: "inline-block" }}>
      {props.status === 1 ? (
        <Box
          component={"div"}
          className={
            props.number === 5
              ? "pj-status-dashboard comm-status"
              : "pj-status comm-status"
          }
        >
          <img src={Check} alt="" />
        </Box>
      ) : props.status === 2 ? (
        <Box
          component={"div"}
          className="pj-status1 comm-status"
          sx={{ color: "#FFFFFF" }}
        >
          {props.number}
        </Box>
      ) : (
        <Box
          component={"div"}
          className="pj-status2 comm-status"
          sx={{ color: "#FFFFFF" }}
        >
          {props.number}
        </Box>
      )}
    </Box>
  );
};

type StatusTextProps = {
  status: Common.PROJECT_STATUS_LIST;
  isLanguage: boolean;
};

const StatusText = (props: StatusTextProps) => {
  const { t } = useTranslation();
  const text = () => {
    let helmertError = false;

    // どちらかがエラー & どちらも成功していない
    if (
      props.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR ||
      props.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      if (
        !(
          props.status.helmert_transformation ===
            Common.PROJECT_STATUS_ENUM.COMPLETED ||
          props.status.coordinate_transformation ===
            Common.PROJECT_STATUS_ENUM.COMPLETED
        )
      ) {
        helmertError = true;
      }
    }

    if (props.status.is_ar) {
      switch (props.status.ar_processing) {
        case Common.PROJECT_STATUS_ENUM.COMPLETED:
        case Common.PROJECT_STATUS_ENUM.INCOMPLETE:
          return t("AR_UPLOAD_COMPLETE");
        case Common.PROJECT_STATUS_ENUM.PROCESSING:
          return t("AR_UPLOAD_CONVERTING");
        case Common.PROJECT_STATUS_ENUM.ERROR:
          return t("AR_UPLOAD_FAILED");
      }
    } else if (helmertError) {
      return t("COORDINATE_CHANGE_ERROR");
    } else if (
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      return t("SFM_PROCESSING_ERROR");
    } else if (props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.ERROR) {
      return t("UPLOAD_ERROR");
    } else if (
      props.status.dashboard_upload_las_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_las_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_txt_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_txt_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.landlog_viewer_upload_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.landlog_viewer_upload_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("DASHBOARD_UPLOAD_COMPLETE");
    } else if (
      props.status.verification_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.verification_sfm === Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("ACCURACY_VERIFY_COMP");
    } else if (
      props.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("COORDINATE_CHANGE_COMPLETE");
    } else if (
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("PROCESSING_DONE");
    } else if (
      props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.WAITING ||
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.PROCESSING ||
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.WAITING
    ) {
      return t("UPLOAD_COMPLETE");
    } else {
      return "";
    }
  };
  return (
    <Typography
      variant="body2"
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        height: "28px",
        lineHeight: "1.0",
      }}
    >
      {text()}
    </Typography>
  );
};

type Props = {
  project: Common.Project;
  selectProject: Common.Project[];
  setSelectProject: (project: Common.Project[]) => void;
  jobsiteNameList: Common.LandlogJobSite[];
  userNameList: Common.ProjectUserList[];
  isLanguage: boolean;
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  isARAvailable: boolean;
};

const Project = (props: Props) => {
  // console.log("project");
  const location = useLocation();
  // ArMarker処理
  const [uploadedFailed, setUploadedFailed] = useState<boolean>(false);
  const [uploadedComp, setUploadedComp] = useState<boolean>(false);
  // shm処理
  const [sfmComp, setSfmComp] = useState<boolean>(false);
  const [sfmFailed, setSfmFailed] = useState<boolean>(false);
  // helmart処理
  const [helmertComp, sethelmertComp] = useState<boolean>(false);
  const [helmertFailed, setHelmertFailed] = useState<boolean>(false);
  // verification処理
  const [verificationComp, setVerificationComp] = useState<boolean>(false);

  const [dashboardUploadComp, setDashboardUploadComp] =
    useState<boolean>(false);

  //削除、プロジェクト名変更ボタン関連
  const [anchorEl, setAnchorEl] = useState(null);

  const [thumbnail, setThumbnail] = useState<string>();
  const [jobsiteName, setJobsiteName] = useState<string>();
  const [userName, setUserName] = useState<string>();
  const [projectName, setProjectName] = useState<string>();
  const [jobsiteId, setJobSiteId] = useState<string>();
  const [openRenameDialog, setOpenRenameDialog] = useState<boolean>();

  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>();

  const [isAR, setIsAR] = useState<boolean>(false);
  const [openARListDialog, setOpenARListDialog] = useState<boolean>(false);

  const [messageModal, setMessageModal] = useState<string>("");

  const getThumbnail = async (controller: AbortController) => {
    try {
      axios
        .get(
          `${config.serverHost}/api/v1/project/${props.project.id}/thumbnail`,
          {
            withCredentials: true,
            signal: controller.signal,
          }
        )
        .then(async (res: AxiosResponse<string>) => {
          axios
            .get(`${res.data}`, {
              responseType: "blob",
              withCredentials: true,
              signal: controller.signal,
            })
            .then(async (res: AxiosResponse<Blob>) => {
              setThumbnail(URL.createObjectURL(res.data));
            });
        });
    } catch (err) {
      console.error(`thumbnail get err ${err}`);
    }
  };

  const isUploadCompletedCheck = async () => {
    try {
      const res: AxiosResponse<Common.ProjectViDoc> =
        await projectDetailAPIs.uploadStatus.get(props.project.id);

      return res.status === 200; //  process COMPLETED
    } catch (err) {
      console.error(`thumbnail get err ${err}`);
    }
  };

  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (!inView || thumbnail) return;
    // console.log("inView");
    const controller = new AbortController();
    getThumbnail(controller);
    const jobsite =
      props.jobsiteNameList?.filter(
        (data) => data.id === props.project.jobSiteId
      )[0]?.name || "";
    setJobsiteName(jobsite);
    const user =
      props.userNameList?.filter(
        (data) => data.userId === props.project.userId
      )[0]?.name || "";
    setUserName(user);

    return () => {
      controller.abort();
    };
  }, [inView]);

  useEffect(() => {
    if (inView) {
      // console.log("props.jobsiteNameList");
      const jobsite =
        props.jobsiteNameList?.filter(
          (data) => data.id === props.project.jobSiteId
        )[0]?.name || "";
      setJobsiteName(jobsite);
      const user =
        props.userNameList?.filter(
          (data) => data.userId === props.project.userId
        )[0]?.name || "";
      setUserName(user);
    }
  }, [props.jobsiteNameList, props.userNameList]);

  const onDismissMessageModal = () => {
    setMessageModal("");
  };

  useEffect(() => {
    setProjectName(props.project.name);
    if (props.project.status) {
      setIsAR(props.project.status.is_ar);
      if (
        props.project.status.lidar_upload ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.lidar_upload ===
          Common.PROJECT_STATUS_ENUM.WAITING ||
        props.project.status.sfm_processing ===
          Common.PROJECT_STATUS_ENUM.PROCESSING ||
        props.project.status.sfm_processing ===
          Common.PROJECT_STATUS_ENUM.WAITING
      ) {
        setUploadedComp(true);
      }
      if (
        props.project.status.lidar_upload === Common.PROJECT_STATUS_ENUM.ERROR
      ) {
        setUploadedFailed(true);
      }
      if (
        props.project.status.sfm_processing ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setSfmComp(true);
      }
      if (
        props.project.status.sfm_processing === Common.PROJECT_STATUS_ENUM.ERROR
      ) {
        setSfmFailed(true);
      }
      if (
        props.project.status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.coordinate_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        sethelmertComp(true);
      }
      if (
        props.project.status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.ERROR ||
        props.project.status.coordinate_transformation ===
          Common.PROJECT_STATUS_ENUM.ERROR
      ) {
        setHelmertFailed(true);
      }
      if (
        props.project.status.verification_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.verification_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setVerificationComp(true);
      }
      if (
        props.project.status.dashboard_upload_las_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.dashboard_upload_las_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.dashboard_upload_txt_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.dashboard_upload_txt_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.landlog_viewer_upload_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.landlog_viewer_upload_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setDashboardUploadComp(true);
      }
    }
  }, []);

  const navigate = useNavigate();
  //プロジェクト削除リスト
  const [selectList, setSelectList] = useState(false);
  //プロジェクト削除有効化フラグ
  const { isDelete } = useContext(deleteContext);
  useEffect(() => {
    if (isDelete === false) {
      setSelectList(false);
      props.selectProject.length = 0;
    }
  });

  const handleList = () => {
    !selectList
      ? props.setSelectProject([...props.selectProject, props.project])
      : props.setSelectProject(
          props.selectProject.filter((arr) => arr.id !== props.project.id)
        );
    setSelectList((prev) => !prev);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteDialogOpen = () => {
    setAnchorEl(null);
  };

  const handleRenameDialogOpen = () => {
    setAnchorEl(null);
  };

  const isEditing = () => {
    const status = props.project.status;
    const EDITING = Common.PROJECT_STATUS_ENUM.PROCESSING;
    return (
      status !== null &&
      (status.helmert_transformation === EDITING ||
        status.coordinate_transformation === EDITING ||
        status.point_splitting_lidar === EDITING ||
        status.remove_lidar === EDITING ||
        status.point_txt_lidar === EDITING ||
        status.point_splitting_sfm === EDITING ||
        status.remove_sfm === EDITING ||
        status.point_txt_sfm === EDITING ||
        status.point_splitting_helmert === EDITING ||
        status.remove_helmert === EDITING ||
        status.point_txt_helmert === EDITING)
    );
  };

  const theme = useTheme();
  const DARK = "dark";
  const removeIcon =
    theme.palette.mode === DARK ? POINT_REMOVE_WHITE_IMG : POINT_REMOVE_IMG;

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customMenuColor = {
    color: theme.palette.base.menu,
  };

  const customBorderColor = {
    color: theme.palette.primary.main,
  };

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customMainColor = {
    background: theme.palette.primary.main,
    boxShadow: "none",
  };

  const RightIcon = () => {
    return (
      <div
        style={{
          height: "24px",
          width: "24px",
          right: "6px",
          position: "absolute",
        }}
      >
        <Icon imagePath={ChevronRight} color={customColor.color} />
      </div>
    );
  };

  return (
    <Grid
      item
      key={props.project.id}
      ref={ref}
      sx={{ margin: "6.5px", padding: "0px" }}
    >
      <Card
        onClick={handleList}
        sx={{
          borderColor: customBorderColor.color,
          margin: "0px",
          width: "220px",
          height: "290px",
          border: selectList ? "solid 2px" : "0px",
        }}
      >
        {inView ? (
          <Box component={"div"}>
            <Box
              component={"div"}
              sx={{
                width: "100%",
                height: "32px",
                verticalAlign: "middle",
                margin: "0px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h5"
                component="h5"
                sx={{
                  height: "100%",
                  width: "100%",
                  paddingLeft: "8px",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  verticalAlign: "middle",
                }}
              >
                <Tooltip
                  title={projectName}
                  arrow
                  placement="top"
                  disableInteractive
                >
                  <Box component={"div"} className="pj-tooltip">
                    {projectName}
                  </Box>
                </Tooltip>
              </Typography>
              <IconButton
                sx={{
                  display: "flex",
                  width: "30px",
                  height: "30px",
                  outline: "none",
                }}
                onClick={handleClick}
              >
                <MoreVert fontSize="medium" sx={customColor} />
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{ top: "10px", borderRadius: "0px", left: "-132px" }}
                PaperProps={{
                  style: {
                    backgroundColor: customMenuColor.color,
                    textAlign: "center",
                    borderRadius: "0px",
                  },
                }}
              >
                <MenuItem
                  onClick={handleRenameDialogOpen}
                  sx={{ width: "230px", padding: "5px", ...customColor }}
                >
                  <RenameProjectDialog
                    projectID={props.project.id}
                    projectName={props.project.name}
                    setProjectName={setProjectName}
                    openDialog={openRenameDialog}
                    setOpenDialog={setOpenRenameDialog}
                  />
                  <div
                    onClick={() => setOpenRenameDialog(true)}
                    style={{
                      width: "100%",
                      height: "100%",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("CHANGE_TITLE")}
                    <RightIcon />
                  </div>
                </MenuItem>
                <MenuItem
                  onClick={handleDeleteDialogOpen}
                  sx={{ width: "230px", padding: "5px", ...customColor }}
                >
                  <DeleteProjectDialog
                    openDialog={openDeleteDialog}
                    setOpenDialog={setOpenDeleteDialog}
                    projectID={props.project.id}
                    projectName={props.project.name}
                  />
                  <div
                    onClick={() => setOpenDeleteDialog(true)}
                    style={{
                      width: "100%",
                      height: "100%",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    {t("REMOVE")}
                    <RightIcon />
                  </div>
                </MenuItem>

                {props.isARAvailable && (
                  <UploadBaseDialog
                    projectID={props.project.id}
                    projectName={props.project.name}
                    setProjectName={setProjectName}
                    isAR={props.project.status.is_ar}
                    jobSiteId={props.project.jobSiteId}
                    setJobSiteId={setJobSiteId}
                    setErrorSnackbar={props.setErrorSnackbar}
                    setErrorMsg={props.setErrorMsg}
                    setOpenWarning={props.setOpenWarning}
                    setMsgWarning={props.setMsgWarning}
                    setAnchorEl={setAnchorEl}
                    ar_color={props.project.ar_color}
                  />
                )}
              </Menu>
            </Box>
            {/* <MsgErrSnackbar
              open={errorSnackbar}
              onClose={handleSnackbarClose}
              msg={t("AR_PROJECT_OPEN_ERROR")}
            /> */}
            <ARListDialog
              open={openARListDialog}
              close={() => {
                setOpenARListDialog(!openARListDialog);
              }}
              project={props.project}
              projectID={props.project.id}
              projectName={props.project.name}
              las_file={props.project.las_file}
              setErrorMsg={props.setErrorMsg}
              setErrorSnackbar={props.setErrorSnackbar}
              ifc_file={props.project.ifc_file}
              vertical={props.project.vertical}
              horizontal={props.project.horizontal}
              jobsiteName={jobsiteName}
            />
            <Box component={"div"} sx={{ position: "relative" }}>
              <CardMedia
                className="hover-cursor"
                component="img"
                height="100px"
                width="220px"
                image={!isAR ? (thumbnail ? thumbnail : MOCK_IMAGE) : AR_IMAGE}
                onClick={async () => {
                  if (!isDelete) {
                    if (isAR) {
                      // setErrorSnackbar(true);
                      setOpenARListDialog(true);
                    } else {
                      let ready = await isUploadCompletedCheck();
                      if (!ready) {
                        setMessageModal(t("PROJECT_UPLOAD_PROCESSING"));
                        return;
                      }
                      sessionStorage.setItem("search", location.search);
                      navigate(`/${props.project.id}`);
                    }
                  }
                }}
              />
              <Avatar
                sx={{
                  backgroundColor: props.project?.useViDoc
                    ? "#2E7D32"
                    : "#4C6CB3",
                  color: "white",
                  position: "absolute",
                  bottom: "0px",
                  right: "0px",
                  height: "24px",
                  width: "44px",
                  fontSize: "small",
                }}
                variant="square"
              >
                <Typography
                  gutterBottom
                  variant="body2"
                  component="div"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    height: "20px",
                    margin: "0px",
                  }}
                >
                  {props.project?.useViDoc ? "RTK" : "GPS"}
                </Typography>
              </Avatar>
            </Box>
            <CardContent
              sx={{
                padding: "8px !important",
                display: "flex",
                flexFlow: "column",
                height: "158px",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="body2"
                component="div"
                sx={{ padding: "0px" }}
              >
                {props.isLanguage
                  ? dayjs(props.project.uploadTime).format(
                      "YYYY/MM/DD HH:mm:ss"
                    )
                  : dayjs(props.project.uploadTime).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
              </Typography>
              <Box
                component={"div"}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Tooltip
                  title={jobsiteName}
                  arrow
                  placement="top"
                  disableInteractive
                >
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "20px",
                      margin: "0px",
                    }}
                  >
                    {jobsiteName}
                  </Typography>
                </Tooltip>
                <Box component={"div"}>
                  {(props.project.status.remove_helmert ===
                    Common.PROJECT_STATUS_ENUM.COMPLETED ||
                    props.project.status.remove_sfm ===
                      Common.PROJECT_STATUS_ENUM.COMPLETED ||
                    props.project.status.remove_lidar ===
                      Common.PROJECT_STATUS_ENUM.COMPLETED) && (
                    <Tooltip
                      title={
                        <span className="tool-tip-cal">
                          {t("REMOVED_POINT_CLOUD")}
                        </span>
                      }
                      arrow
                      placement="top"
                      disableInteractive
                    >
                      <img src={removeIcon} alt="" />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Typography
                gutterBottom
                variant="body2"
                component="div"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  height: "20px",
                  margin: "0px",
                }}
              >
                {userName}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  component={"div"}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <StatusIcon
                    status={uploadedComp ? 1 : uploadedFailed ? 2 : 0}
                    number={1}
                  />
                  <span style={{ margin: "0 3px" }}></span>
                  <StatusIcon
                    status={sfmComp ? 1 : sfmFailed ? 2 : 0}
                    number={2}
                  />
                  <span style={{ margin: "0 3px" }}></span>
                  <StatusIcon
                    status={helmertComp ? 1 : helmertFailed ? 2 : 0}
                    number={3}
                  />
                  <span style={{ margin: "0 3px" }}></span>
                  <StatusIcon status={verificationComp ? 1 : 0} number={4} />
                  <span style={{ margin: "0 3px" }}></span>
                  <StatusIcon status={dashboardUploadComp ? 1 : 0} number={5} />
                </Box>
                {isEditing() && (
                  <Tooltip
                    title={
                      <span className="tool-tip-cal">{t("WHILE_EDIT")}</span>
                    }
                    arrow
                    placement="top"
                    disableInteractive
                  >
                    <DownloadingIcon
                      sx={{
                        color:
                          theme.palette.mode === DARK ? "white" : "#140A94",
                        width: "24px",
                        height: "24px",
                        transform: "rotate(180deg)",
                      }}
                    />
                  </Tooltip>
                )}
              </Box>
              <StatusText
                status={props.project.status}
                isLanguage={props.isLanguage}
              />
            </CardContent>
            {/* アップロード完了ダイアログ */}
            <Dialog
              open={!!messageModal && messageModal.trim() !== ""}
              PaperProps={{
                className: "message-modal-container",
                style: { ...customBackgroundStyles },
              }}
              slotProps={{
                backdrop: {
                  sx: {
                    backgroundColor: customDialogBackgroundColor.color,
                  },
                },
              }}
            >
              <DialogContentText
                sx={{
                  padding: "0 20px",
                  textAlign: "center !important",
                  color: theme.palette.text.primary,
                  width: "100%",
                }}
                id="upload-file20"
              >
                {messageModal}
              </DialogContentText>
              <Button
                style={customMainColor}
                className="upload-file22"
                size="small"
                variant="contained"
                onClick={onDismissMessageModal}
              >
                {"OK"}
              </Button>
            </Dialog>
          </Box>
        ) : (
          <></>
        )}
      </Card>
    </Grid>
  );
};

export default Project;
